var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-btn',{class:_vm.$style.component,attrs:{"color":_vm.buttonColor,"dark":"","outlined":""},on:{"click":_vm.goToQuote}},[_vm._v(" Request a Quote ")])
}
var staticRenderFns = []

export { render, staticRenderFns }